import Entry from '@/modules/log/model/Entry'
import Level from '@/modules/log/model/Level'
import Logger from '@/modules/log/Log'
import EventViewer from '@/modules/log/components/EventViewer.vue';

export function routes () {
    return [
        {
            name: 'event_viewer',
            path: '/log/visor',
            component: EventViewer,
            meta: {
                auth: true,
                toolbarTitle: 'Visor de eventos',
                module: 'log',
            },
        },
    ]
}

export function menu () {
    return [
        {
            title: 'Registros de eventos',
            icon: 'mdi-server',
            routeName: 'event_viewer',
            module: 'log',
        },
    ]
}

export default Logger
export { Entry, Level }
